export default __webpack_public_path__ + "static/media/978.3fe1fc44.png";